






































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { TableColumnItemType, OperationItemType, TabItem, OptionItemType } from '../../types/type'
import Store, { CommonModule } from '../../store'
import { Pagination } from '../../mixins/pagination'
import { findItemForTree, getArrChildForTree, getNameTextInOptions, getSuffix } from '../../utils/toolsForCommon'
import axios from 'axios'
import { encode } from 'js-base64'
@Component({
  name: 'CostSupervise',
  mixins: [Pagination],
  components: {
    'my-table': () => import('../../components/common/myTable/index.vue'),
    'my-dialog': () => import('../../components/common/myDialog.vue'),
    'loading-container': () => import('../../components/loading.vue')
  }
})
export default class CostSupervise extends Vue {
  public loading: boolean = false
  public paneName: string = 'uncompletedAlert'
  public tablist: Array<TabItem> = [
    {
      title: '全部预警',
      key: 'uncompletedAlert'
    },
    {
      title: '未处理预警',
      key: 'unprocessedAlert'
    },
    {
      title: '预警历史',
      key: 'processedAlert'
    }
  ]
  // tree相关：
  public filterText: string = ''
  public checkedKeysForTree: Array<string | number> = []
  // 食材成本监管预警相关：
  // 列表列有哪些：
  public foodCostModuleTitleList: Array<TableColumnItemType> = [
    {
      title: '乡镇',
      key: 'town',
      flex: 1,
      width: '200px'
    },
    {
      title: '学校名称',
      key: 'school',
      flex: 1,
      width: '200px'
    },
    {
      title: '预警类型',
      key: 'type',
      flex: 1,
      width: '100px'
    },
    {
      title: '预警内容',
      key: 'content',
      flex: 1,
      width: '300px'
    },
    {
      title: '预警时间',
      key: 'createdTime',
      flex: 1,
      width: '200px'
    },
    {
      title: '状态',
      key: 'status',
      flex: 1,
      width: '120px'
    },
    {
      title: '操作',
      key: 'operationInTable',
      flex: 1,
      width: '160px'
    }
  ]
  public foodCostModuleTitleListHandler: Array<TableColumnItemType> = [
    {
      title: '乡镇',
      key: 'town',
      flex: 1,
      width: '200px'
    },
    {
      title: '学校名称',
      key: 'school',
      flex: 1,
      width: '200px'
    },
    {
      title: '预警类型',
      key: 'type',
      flex: 1,
      width: '100px'
    },
    {
      title: '预警内容',
      key: 'content',
      flex: 1,
      width: '300px'
    },
    {
      title: '预警时间',
      key: 'createdTime',
      flex: 1,
      width: '200px'
    },
    {
      title: '状态（整体状态）',
      key: 'status',
      flex: 1,
      width: '120px'
    },
    {
      title: '操作',
      key: 'operationInTable',
      flex: 1,
      width: '160px'
    }
  ]
  // 列表内容有哪些：
  public foodCostModuleBodyList: Array<any> = []
  // 列表每一行的操作有哪些：
  public columnOperationListForFoodCostModuleBodyList: Array<OperationItemType> = [
    {
      title: '查看处理记录',
      key: 'disposeLog',
      type: 'primary',
      size: 'mini'
    }
  ]
  public columnOperationListForFoodCostModuleBodyListHandler: Array<OperationItemType> = [
    {
      title: '查看处理记录',
      key: 'disposeLog',
      type: 'primary',
      size: 'mini'
    }
  ]
  // 枚举选项：
  public optionsForType: Array<OptionItemType> = [
    {
      name: '食材支出占比',
      value: 1
    },
    {
      name: '食材单价',
      value: 2
    },
    {
      name: '自制凭证',
      value: 3
    },
    // {
    //   name: '日常预警',
    //   value: 4
    // },
    {
      name: '记账',
      value: 5
    }
  ]
  public optionsForStatus: Array<OptionItemType> = [
    {
      name: '待处理',
      value: 0
    },
    {
      name: '通过',
      value: 1
    },
    {
      name: '驳回',
      value: 2
    }
  ]
  // 查询：
  public typeForSearch: number | string = ''
  public keywordsForSearch: string = ''
  public timerIdForInputForKeywordsForSearch: number = 0
  // 角标：
  public hintForNum: number | number = 0
  // 处理弹框相关：
  public dialogFlagForDispose: boolean = false
  public loadingForDispose: boolean = false
  public radioForAudit: boolean | string = ''
  public reasonForDispose: string = ''
  public transferFile: string = ''
  public disposeForWho: string = ''
  public disposeRole: string = ''
  // 附件预览：
  public dialogVisibleForPreviewFile: boolean = false
  public dialogVisiblePreviewUrl: string = ''
  public dialogVisibleiframeShowFlag: boolean = false
  // 查看处理详情：
  public visibleForFailBackDetailList: boolean = false
  public failBackDetailList: Array<any> = []
  public loadingForFailBackDetailList: boolean = false

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  @Watch('filterText') filterTextChange (val: any) {
    ;(this as any).$refs[`${this.paneName}OfTree`][0].filter(val)
  }

  async mounted () {
    const { paneName } = this.$route.query
    paneName && (this.paneName = paneName as string)
    await Promise.all([
      CommonModule.getTreeDataForSubOrganization(),
      CommonModule.getTreeDataForOrganization()
    ])
    this.$nextTick(() => {
      this.treeInit()
      this.getTableDataList()
      // 处理以上的正常操作：
      // 还需要提前查询第二个tab里面的内容，因为需要展示角标：
      // 所以对getTableDataList新增了参数：
      this.getTableDataList('unprocessedAlert')
    })
    // 判断是否是学校节点：
    // console.log(this.treeDataForSubOrganatizion, 'treeDataForSubOrganatizion')
    if (this.treeDataForSubOrganatizion[0].hasOwnProperty('children')) {
      // console.log('不是学校')
      this.columnOperationListForFoodCostModuleBodyList = [
        {
          title: '处理',
          key: 'disposeForNoSchool',
          type: 'primary',
          size: 'mini'
        },
        {
          title: '查看处理记录',
          key: 'disposeLog',
          type: 'primary',
          size: 'mini'
        }
      ]
    } else {
      // console.log('是学校')
      this.columnOperationListForFoodCostModuleBodyList = [
        {
          title: '处理',
          key: 'disposeForSchool',
          type: 'primary',
          size: 'mini'
        },
        {
          title: '查看处理记录',
          key: 'disposeLog',
          type: 'primary',
          size: 'mini'
        }
      ]
    }
    this.$on('hook:beforeDestroy', () => {
      this.timerIdForInputForKeywordsForSearch && clearTimeout(this.timerIdForInputForKeywordsForSearch)
    })
  }

  treeInit () {
    const list = getArrChildForTree(this.treeDataForSubOrganatizion, 'children').map(item => item.id)
    if (list.length) {
      // this.checkedKeysForTree = [list[0]]
      // 默认选中全部：
      this.checkedKeysForTree = [...list]

      ;(this as any).$refs[`${this.paneName}OfTree`][0].setCheckedKeys(this.checkedKeysForTree)
    }
  }

  filterNode (value: any, data: any) {
    if (!value) return true
    return data.name.indexOf(value) !== -1
  }

  handleCheckChange (current, { checkedKeys }): void {
    // 原本是这样，但是缺点是：会把所有选中的节点都带上：
    // this.checkedKeysForTree = checkedKeys
    // 但实际只需要末节点：
    this.checkedKeysForTree = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
    if (this.checkedKeysForTree.length) {
      this.getTableDataList()
    } else {
      this.foodCostModuleBodyList = []
      ;(this as any).total = 0
      if (this.paneName === 'unprocessedAlert') this.hintForNum = 0
    }
  }

  changeForTypeForSearch () {
    this.getTableDataList()
  }

  inputForKeywordsForSearch () {
    this.timerIdForInputForKeywordsForSearch && clearTimeout(this.timerIdForInputForKeywordsForSearch)
    this.timerIdForInputForKeywordsForSearch = setTimeout(() => {
      this.getTableDataList()
    }, 500)
  }

  async getTableDataList (specialPaneName?: string) {
    try {
      if (specialPaneName && specialPaneName === 'unprocessedAlert') {
        // console.log('这里走特殊判断，传了参数代表只是更新第二个的角标，并不能替换列表')
        const pageParams = {
          pageNo: 1,
          pageSize: 10
        }
        const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
        const searchParams = {
          school: listForGetCheckedKeys,
          type: '',
          content: ''
        }
        const params = {
          ...pageParams,
          ...searchParams,
          status: [0] // 0：待处理，1：通过，2：驳回
        }
        const { data: result } = await (this as any).$http.warningInfoQuery(params)
        if (result.code !== 200) return
        this.hintForNum = Number(result.data.total) > 99 ? '99+' : result.data.total
        return
      }
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
      const searchParams = {
        school: listForGetCheckedKeys,
        type: this.typeForSearch,
        content: this.keywordsForSearch
      }
      const params = {
        ...pageParams,
        ...searchParams
      }
      let api = ''
      if (this.paneName === 'unprocessedAlert') {
        api = 'warningInfoQuery'
        Object.assign(params, {
          status: [0] // 0：待处理，1：通过，2：驳回
        })
      } else if (this.paneName === 'processedAlert') {
        api = 'warnInfoQueryHandler'
      } else if (this.paneName === 'uncompletedAlert') {
        api = 'warningInfoQueryNotComplete'
      }
      const { data: result } = await (this as any).$http[api](params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.foodCostModuleBodyList = ((result.data && result.data.records) || []).map(item => {
        item.town = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', item.town)['name']
        item.school = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', item.school)['name']
        item.type = getNameTextInOptions(this.optionsForType, item.type)
        item.status = getNameTextInOptions(this.optionsForStatus, item.status)
        return item
      })
      _that.total = result.data.total
      if (this.paneName === 'unprocessedAlert') this.hintForNum = Number(_that.total) > 99 ? '99+' : _that.total
    } catch (err) {
      console.log(err)
    }
  }

  // 操作按钮：
  operationForButton ({ key }, row) {
    const { id } = row
    switch (key) {
      case 'disposeForSchool':
      case 'disposeForNoSchool':
        this.disposeRole = key
        this.dialogFlagForDispose = true
        this.disposeForWho = row
        break
      case 'disposeLog':
        this.visibleForFailBackDetailList = true
        this.getdisposeDetail(id)
        break
    }
  }

  async getdisposeDetail (id) {
    try {
      this.failBackDetailList = []
      this.loadingForFailBackDetailList = true
      const params = {
        auditScene: 4, // 1: 会计凭证审核;2:资金转账记录;3:资金使用申请;4:预警
        id
      }
      const { data: result } = await (this as any).$http.getLogAudit(params)
      this.loadingForFailBackDetailList = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.failBackDetailList = (result.data || []).map(item => {
        let res = ''
        const NodeRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', item['operatorOrg'])
        if (!Object.keys(NodeRes).length) {
          res = '- -'
        } else {
          res = NodeRes['name']
        }
        item.description = `
          ${item.audit ? '通过' : '驳回'}
          ----
          ${res}
          组织节点的用户（
          ${item['operatorName']}
          ）在
          ${item['time']}
          进行处理，处理完的状态为：
          ${getNameTextInOptions(this.optionsForStatus, item['resultStatus'])}
          ，处理原因为：
          ${item['reason'] ? item['reason'] : '- -'}
        `
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  async confirmDispose () {
    try {
      if (this.disposeRole !== 'disposeForSchool' && this.radioForAudit === '') return this.$message.warning('请选择处理结果')
      if (this.radioForAudit === false && !this.reasonForDispose) return this.$message.warning(this.disposeRole === 'disposeForSchool' ? '请输入处理情况说明' : '请输入处理理由')
      const params = {
        ids: [this.disposeForWho['id']],
        audit: this.disposeRole === 'disposeForSchool' ? true : this.radioForAudit,
        reason: this.reasonForDispose,
        file: this.transferFile
      }
      this.loadingForDispose = true
      let { data: result } = await (this as any).$http.warningInfoAudit(params)
      this.loadingForDispose = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('操作成功')
      this.getTableDataList()
      this.reasonForDispose = this.transferFile = ''
      this.dialogFlagForDispose = false
      console.log(params)
    } catch (err) {
      console.log(err)
    }
  }

  beforeLeave (activeName: string): void {
    ;(this.$refs[`${activeName}OfTree`][0] as any).filter(this.filterText)
    ;(this as any).$refs[`${activeName}OfTree`][0].setCheckedKeys(this.checkedKeysForTree)
    this.$router.replace({ name: 'CostSupervise', query: { paneName: activeName } })
    this.paneName = activeName
    if (this.checkedKeysForTree.length) {
      this.getTableDataList()
    } else {
      this.foodCostModuleBodyList = []
      ;(this as any).total = 0
      if (this.paneName === 'unprocessedAlert') this.hintForNum = 0
    }
  }

  operationForDownload (): void {
    switch (this.paneName) {
      case 'unprocessedAlert':
        {
          this.loading = true
          const keysList = this.foodCostModuleTitleList.map(v => v.key).filter(vv => vv !== 'operationInTable')
          const dataRes = ((this as any).foodCostModuleBodyList || []).map(v => {
            return keysList.map(vv => {
              let res = ''
              switch (vv) {
                default:
                  res = v[vv]
              }
              return res
            })
          })
          import('../../plugins/xlsx/exportExcel').then(excel => {
            let tHeader = this.foodCostModuleTitleList.map(v => v.title).filter(vv => vv !== '操作')
            try {
              excel.export_json_to_excel({
                multiHeader2: [], // 这里是第一行的表头
                multiHeader: [], // 这里是第二行的表头
                header: tHeader, // 这里应该是算第三行的表头
                data: dataRes,
                merges: [],
                filename: '食堂成本监管（未处理预警）.xlsx'
              })
              this.$message.success('食堂成本监管（未处理预警），导出成功')
            } catch (err) {
              this.$message.error('抱歉，导出失败')
            }
          })
          setTimeout(() => {
            this.loading = false
          }, 300)
        }
        break
      case 'processedAlert':
        {
          this.loading = true
          const keysList = this.foodCostModuleTitleListHandler.map(v => v.key).filter(vv => vv !== 'operationInTable')
          const dataRes = ((this as any).foodCostModuleBodyList || []).map(v => {
            return keysList.map(vv => {
              let res = ''
              switch (vv) {
                default:
                  res = v[vv]
              }
              return res
            })
          })
          import('../../plugins/xlsx/exportExcel').then(excel => {
            let tHeader = this.foodCostModuleTitleListHandler.map(v => v.title).filter(vv => vv !== '操作')
            try {
              excel.export_json_to_excel({
                multiHeader2: [], // 这里是第一行的表头
                multiHeader: [], // 这里是第二行的表头
                header: tHeader, // 这里应该是算第三行的表头
                data: dataRes,
                merges: [],
                filename: '食堂成本监管（预警历史）.xlsx'
              })
              this.$message.success('食堂成本监管（预警历史），导出成功')
            } catch (err) {
              this.$message.error('抱歉，导出失败')
            }
          })
          setTimeout(() => {
            this.loading = false
          }, 300)
        }
        break
      case 'uncompletedAlert':
        {
          this.loading = true
          const keysList = this.foodCostModuleTitleListHandler.map(v => v.key).filter(vv => vv !== 'operationInTable')
          const dataRes = ((this as any).foodCostModuleBodyList || []).map(v => {
            return keysList.map(vv => {
              let res = ''
              switch (vv) {
                default:
                  res = v[vv]
              }
              return res
            })
          })
          import('../../plugins/xlsx/exportExcel').then(excel => {
            let tHeader = this.foodCostModuleTitleListHandler.map(v => v.title).filter(vv => vv !== '操作')
            try {
              excel.export_json_to_excel({
                multiHeader2: [], // 这里是第一行的表头
                multiHeader: [], // 这里是第二行的表头
                header: tHeader, // 这里应该是算第三行的表头
                data: dataRes,
                merges: [],
                filename: '食堂成本监管（全部预警）.xlsx'
              })
              this.$message.success('食堂成本监管（全部预警），导出成功')
            } catch (err) {
              this.$message.error('抱歉，导出失败')
            }
          })
          setTimeout(() => {
            this.loading = false
          }, 300)
        }
        break
    }
  }

  // 暂时不作限制
  beforeUpload () {}

  mySelfUploadForTransferFile (param) {
    this.mySelfUploadFile(param, 'transferFile')
  }

  async mySelfUploadFile (param, who) {
    const _that = this
    const params = {
      contentType: param.file.type,
      suffix: getSuffix(param.file.name)
    }
    this.loadingForDispose = true
    const { data: result } = await (this as any).$http.uploadFile(params)
    if (result.code !== 200) return this.$message.error(result.msg)
    let reader = new FileReader()
    reader.readAsArrayBuffer(param.file)
    reader.onload = async function () {
      const onloadResult = reader.result
      await axios.put(result.data, onloadResult, {
        headers: {
          'Content-Type': param.file.type,
          authorization: Store.state.User.token
        }
      })
      _that.$message.success('上传成功')
      const url = result.data.split('?')[0]
      const obj = {
        url,
        name: param.file.name
      }
      _that[who] = JSON.stringify(obj)
      _that.loadingForDispose = false
    }
  }

  // 预览：
  previewBtn (v) {
    let _that: any = this
    this.dialogVisibleForPreviewFile = true
    let previewUrl = _that.$previewURL + '/onlinePreview?url=' + encodeURIComponent(encode(v))
    this.dialogVisiblePreviewUrl = previewUrl
  }

  // 预览框打开的时候：
  dialogVisibleOpened () {
    let _that: any = this
    _that.dialogVisibleiframeShowFlag = false
    _that.$nextTick(() => {
      let iframeBox = document.querySelector('#iframeBoxOfdialogVisible')
      if ((iframeBox as any).attachEvent) {
        ;(iframeBox as any).attachEvent('onload', function () {
          _that.dialogVisibleiframeShowFlag = true
        })
      } else {
        ;(iframeBox as any).onload = function () {
          _that.dialogVisibleiframeShowFlag = true
        }
      }
      _that.dialogVisibleiframeShowFlag = true
    })
  }
}
